import {NgModule} from '@angular/core';
import {TopNavComponent} from './top-navigation.component';
import {CommonModule} from '@angular/common';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap';
import {RouterModule} from '@angular/router';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  declarations: [TopNavComponent],
  imports: [CommonModule, RouterModule, CollapseModule.forRoot(),BsDropdownModule.forRoot(),FormsModule, ReactiveFormsModule],
  providers: [],
  exports: [TopNavComponent],
})
export class TopNavModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/top-navigation/top-navigation.module.ts